<template>
  <div class="floor" v-show="floorShow">
    <div class="change-floor">
      <div class="floor-text">
        {{this.floorList[floorNum].num}}
      </div>
      <div class="up" @click="up()"></div>
      <div class="down" @click="down()"></div>
    </div>
    <div class="floor-box"></div>
    <div class="floor-num">
      <div class="floor-change" :style="'bottom: '+this.bottom + 'px'">
        <div class="num" v-for="(item,i) in floorList" :key="i" :class="{active:item.state}">{{item.num}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "FloorFiltering",
    data() {
      return {
        floorList: [
          {
            "num": "19F",
            "name": "LA9",
            "state": false
          },
          {
            "num": "18F",
            "name": "LA8",
            "state": false
          },
          {
            "num": "17F",
            "name": "LA7",
            "state": false
          },
          {
            "num": "16F",
            "name": "LA6",
            "state": false
          },
          {
            "num": "15F",
            "name": "LA5",
            "state": false
          },
          {
            "num": "14F",
            "name": "LA4",
            "state": false
          },
          {
            "num": "13F",
            "name": "LA3",
            "state": false
          },
          {
            "num": "12F",
            "name": "LA2",
            "state": false
          },
          {
            "num": "11F",
            "name": "LA1",
            "state": false
          },
          {
            "num": "10F",
            "name": "LA0",
            "state": false
          },
          {
            "num": "9F",
            "name": "L9",
            "state": false
          },
          {
            "num": "8F",
            "name": "L8",
            "state": false
          },
          {
            "num": "7F",
            "name": "L7",
            "state": false
          },
          {
            "num": "6F",
            "name": "L6",
            "state": false
          },
          {
            "num": "5F",
            "name": "L5",
            "state": false
          },
          {
            "num": "4F",
            "name": "L4",
            "state": false
          },
          {
            "num": "3F",
            "name": "L3",
            "state": false
          },
          {
            "num": "2F",
            "name": "L2",
            "state": false
          },
          {
            "num": "1F",
            "name": "L1",
            "state": false
          },{
            "num": "0F",
            "name": "L0",
            "state": true
          }
        ],
        active: 0,
        floorShow: false,
        floor: '',
        icon: [],
        floorNum:19,
        bottom:360,
        text:'0F'
      }
    },
    mounted() {
      window.floorShow = this.show
      window.recovery = this.recovery
      this.$icos.$on('getIcon', (data) => {
        this.icon = data;
      })
    },
    methods: {
      //楼层选择隐藏并恢复初始状态
      recovery() {
        this.floorShow = false;
        this.active = 0;
        this.floorNum = 19;
        this.bottom = 360;
        this.text = '0F';
        this.floorList[19].state = true
      },
      show() {
        this.floorShow = true
      },
      activeFloor(num) {
        for(let i = 0; i < this.floorList.length;i++){
          if(i!=num){
            this.floorList[i].state = false;
          }else {
            this.floorList[i].state = true;
          }
        }

        if(num==19){
          return;
        }
        this.active = num;
        this.$floors.$emit('changFloor', this.floorList[num].name);
        document.getElementById('iframe').contentWindow.MMAPI.focusLc(this.floorList[num].name, this.icon)
        window.devHandle(-1)
      },
      up(){


        if(this.floorNum<0){
        }else {
          this.floorNum--;
          this.bottom = this.bottom-72;
          console.log(this.bottom)
          this.activeFloor(this.floorNum)
        }

      },
      down(){


        if(this.floorNum>19){
        }else {
          this.floorNum++;
          this.bottom = this.bottom+72;
          this.activeFloor(this.floorNum)
        }

      }
    }
  }
</script>

<style scoped lang="less">
  .floor {
    z-index: 9999;
    height: 804px;
    position: absolute;
    right: 402px;
    top: 10%;
    width: 60px;
    .change-floor {
      background: url("./../assets/change-floor.png") no-repeat;
      background-size: 100% 100%;
      width: 126px;
      height: 131px;
      position: absolute;
      top: 372px;/*no*/
      right: 0;
      .floor-text{
        position: absolute;
        right: 40px;
        top: 22px;
        font-size: 41.66px;
        font-family: "SimHei";
        color: rgb(255, 167, 16);
      }
      .up{
        position: absolute;
        top: 0;
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
      .down{
        position: absolute;
        bottom: 0;
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
    }

    .floor-box {
      background: url("./../assets/floor-bg.png") no-repeat;
      background-size: 100% 100%;
      width: 24px;
      height: 795px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }

    .floor-num {
      width: 30px;
      height: 809px;
      position: absolute;
      left: 0;
      bottom: 0;
    overflow: hidden;
      .floor-change {

        width: 30px;
        position: absolute;
        bottom: 360px;/*no*/
        .num {
          &.active{
           opacity: 0;
          }
          &:last-of-type{
            margin-bottom: 0;
          }
          height: 20px;
          font-family: 黑体;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.502);
          margin-bottom: 52px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
</style>
